import { differenceInCalendarDays, subDays } from 'date-fns';

// Keeps the end date and pulls the start in so the window spans at most `maxDays` days, both ends included.
export function clampRangeToMaxDays(startDate: Date, endDate: Date, maxDays: number) {
  if (differenceInCalendarDays(endDate, startDate) < maxDays) return { startDate, endDate };
  return { startDate: subDays(endDate, maxDays - 1), endDate };
}
